import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError, AxiosInstance } from 'axios';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';
import { ActiveTenantFeatureSubscriptions } from 'shared/providers/tenant-feature-subscriptions/domain/models/active-tenant-feature-subscription';

const featureSubscriptionsBaseUrl = '/api/v1/FeatureSubscriptions';
const forbiddenHttpStatusCode = 403;

export const FeatureSubscriptionsQueryPaths = {
  ReadActiveTenantFeatureSubscriptions: 'ReadActiveTenantFeatureSubscriptions',
};

const getActiveTenantFeatureSubscriptions = async (axiosInstance: AxiosInstance): Promise<ActiveTenantFeatureSubscriptions> => {
  const response = await axiosInstance.get(
    `${featureSubscriptionsBaseUrl}/${FeatureSubscriptionsQueryPaths.ReadActiveTenantFeatureSubscriptions}`,
  );
  return response.data;
};

export const useLazyGetActiveTenantFeatureSubscriptionsQuery = (): UseQueryResult<ActiveTenantFeatureSubscriptions> => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useQuery({
    queryKey: [FeatureSubscriptionsQueryPaths.ReadActiveTenantFeatureSubscriptions],
    queryFn: () => getActiveTenantFeatureSubscriptions(authenticatedInstance),
    enabled: false,
    retry: (failureCount, error) => {
      if (error instanceof AxiosError && error.response?.status === forbiddenHttpStatusCode) {
        return false;
      }
      return failureCount < 3;
    },
  });
};
